import React from 'react';
import { Skeleton, Table } from '@mantine/core';
import { DataTableColumn } from '.';

interface LoaderDataTablesProps {
  columns: DataTableColumn[];
  isNumbering?: boolean;
}

const LoaderDataTables: React.FC<LoaderDataTablesProps> = ({ columns, isNumbering }) => {
  const activeColumn = columns.filter((column) => column.active === true);
  return (
    <Table.Tbody>
      {[...Array(5)].map((_, index) => (
        <Table.Tr key={`row-${index}`}>
          <Table.Td
            colSpan={isNumbering ? activeColumn.length + 1 : activeColumn.length}
            style={{ textAlign: 'center' }}
          >
            <Skeleton width='100%' height={18} />
          </Table.Td>
        </Table.Tr>
      ))}
    </Table.Tbody>
  );
};

export default LoaderDataTables;
